<template>
  <div ref="container" class="grid-lines">
    <div class="wrapper">
      <svg ref="svg" viewBox="0 0 1240 1240" version="1.1" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
          <path d="M0.5,0 L0.5,1240" stroke="#eee" fill-rule="nonzero"></path>
          <rect x="1" y="0" width="155" height="1240" fill="#fff"></rect>
          <path d="M155.5,0 L155.5,1240" stroke="#eee" fill-rule="nonzero"></path>
          <rect x="156" y="0" width="155" height="1240" fill="#fff"></rect>
          <path d="M310.5,0 L310.5,1240" stroke="#eee" fill-rule="nonzero"></path>
          <rect x="311" y="0" width="155" height="1240" fill="#fff"></rect>
          <path d="M465.5,0 L465.5,1240" stroke="#eee" fill-rule="nonzero"></path>
          <rect x="466" y="0" width="155" height="1240" fill="#fff"></rect>
          <path d="M620.5,0 L620.5,1240" stroke="#eee" fill-rule="nonzero"></path>
          <rect x="621" y="0" width="155" height="1240" fill="#fff"></rect>
          <path d="M774.5,0 L774.5,1240" stroke="#eee" fill-rule="nonzero"></path>
          <rect x="775" y="0" width="155" height="1240" fill="#fff"></rect>
          <path d="M929.5,0 L929.5,1240" stroke="#eee" fill-rule="nonzero"></path>
          <rect x="930" y="0" width="155" height="1240" fill="#fff"></rect>
          <path d="M1084.5,0 L1084.5,1240" stroke="#eee" fill-rule="nonzero"></path>
          <rect x="1085" y="0" width="155" height="1240" fill="#fff"></rect>
          <path d="M1239.5,0 L1239.5,1240" stroke="#eee" fill-rule="nonzero"></path>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { TweenMax } from 'gsap/TweenMax';

export default {
  data() {
    return {
      tl: null,
      speed: 0.5,
      staggerDelay: 0.05,
      done: false,
      paths: null,
      rects: null
    }
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    }
  },
  methods: {
    show() {
      this.tl.restart();
    },
    hide() {
      this.tl.reverse();
    }
  },
  mounted() {
    // this.tl = new TimelineMax({paused:true});
    // this.tl.call(() => {
    //   this.done = false;
    // })
    // this.tl.set(this.$refs.container, {"z-index": 999});
    // this.tl.staggerFrom(this.$refs.svg.querySelectorAll('rect'), this.speed, {scaleY: 0, opacity: 1}, this.staggerDelay, 0)
    // this.tl.staggerFromTo(this.$refs.svg.querySelectorAll('path'), this.speed, {drawSVG:"0", opacity: 1}, {drawSVG:"1240", opacity: 1}, this.staggerDelay, 0)
    // this.tl.set(this.$refs.container, {"z-index": -1});
    // this.tl.call(() => {
    //   this.done = true;
    // })

    this.paths = this.$refs.svg.querySelectorAll('path');
    this.rects = this.$refs.svg.querySelectorAll('rect');

    TweenMax.staggerFromTo(this.paths, this.speed, {drawSVG:"0", opacity: 1}, {drawSVG:"1240", opacity: 1}, this.staggerDelay)

    // this.$router.beforeEach((to, from, next) => {
    //   console.log("before");
    //   console.log(this.$router)
    //   const tl = new TimelineMax();
    //   // tl.staggerFromTo(this.paths, 0.2, {drawSVG:"1240"}, {drawSVG:"0"}, 0.05, 0)
    //   tl.add("show")
    //   // tl.to(document.body, this.speed, { backgroundColor: "#f4f4f4"}, "show");
    //   // tl.to('.view', 0.5, {opacity: 0}, "show");
    //   tl.set(this.$refs.container, {"z-index": 99});
    //   tl.staggerFromTo(this.paths, this.speed, {drawSVG:"0"}, {drawSVG:"1240"}, this.staggerDelay, "show")
    //   tl.staggerFromTo(this.rects, this.speed, {scaleX: 0}, { scaleX: 1, transformOrigin: "0% 50%"}, this.staggerDelay, "show")
    //   tl.add("hide")
    //   tl.to('.router-view', 0, {opacity: 0}, "hide");
    //   tl.staggerFromTo(this.rects, this.speed, {scaleX: 1}, { scaleX: 0}, this.staggerDelay, "hide");
    //   tl.set(this.$refs.container, {"z-index": -1});
    //   tl.call(() => {
    //     next();
    //    })
    // });
    // this.$router.afterEach((to, from) => {
    //   console.log("after");
    //   const tl = new TimelineMax();
    //   tl.to('.router-view', 0, {opacity: 1});
    // })
  },
}
</script>


<style lang="scss" scoped>

.grid-lines {
  position: fixed;
  top: 0;
  left: 25px;
  right: 25px;
  height: 100%;
  z-index: -1;
  pointer-events: none;
  transform: translateZ(0);

  @media screen and (min-width: 768px) {
    left: 50px;
    right: 50px;
  }

  .wrapper {
    position: relative;
    width: 100%;
    max-width: 1240px;
    height: 100%;
    margin: 0 auto;
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

</style>